import React from 'react';
import { useIntl } from 'react-intl';
import { Box, Grid, useTheme } from '@mui/material';
import { ParentSize } from '@visx/responsive';
import GraphsLegend from '../../../Components/Charts/GraphsLegend';
import DonutChart from '../../../Components/Charts/DonutChart';
import DataBox from '../../Dashboard/DataBox';
import { ColumnFlexBox, FullSizeFlexBox } from '../../../Components/FlexBox';
import CaptionValue from '../../../Components/CaptionValue/CaptionValue';

const AppointmentsOutcomeCounters = function AppointmentsOutcomeCounters({
  outcomeCounters,
}) {
  const intl = useIntl();
  const theme = useTheme();

  const colors = theme.custom.generateConsistentUniqueColors(
    outcomeCounters?.map(({ name }) => name)
  );
  const total = outcomeCounters?.reduce((acc, curr) => acc + curr.count, 0);

  return (
    <FullSizeFlexBox gap="1vw">
      <ColumnFlexBox flex="0 0 30%" gap="1vh">
        <DataBox
          flex="0 1 20%"
          widget={
            <CaptionValue
              caption="TOTAL"
              value={outcomeCounters
                ?.reduce((acc, curr) => acc + curr.count, 0)
                ?.toString()}
              valueColor="#8D4EDA"
              textAlign="center"
              captionStyle={{ fontSize: '20px', fontWeight: 'bold' }}
              valueStyle={{ fontSize: '32px', fontWeight: 'bold' }}
            />
          }
        />
        <DataBox
          title={intl.messages.OUTCOMES}
          padding="0px"
          flex="1 1 70%"
          widget={
            <Grid spacing={2} container>
              {outcomeCounters?.map(({ name, count }, index) => (
                <Grid size={6} key={name}>
                  <CaptionValue
                    key={name}
                    caption={intl.messages[name?.toUpperCase()] ?? name}
                    value={count?.toString()}
                    valueColor={colors[index][theme.palette.mode]}
                    textAlign="center"
                    captionStyle={{ fontSize: '16px', fontWeight: 'bold' }}
                    valueStyle={{ fontSize: '24px', fontWeight: 'bold' }}
                  />
                </Grid>
              ))}
            </Grid>
          }
        />
      </ColumnFlexBox>
      <DataBox
        flex="1 1 70%"
        title={intl.messages.APPOINTMENTS_OUTCOMES}
        widget={
          <Box
            sx={{
              p: "1vh",
              display: "flex",
              height: "270px",
              width: "auto",
              overflow: "hidden",
              textOverflow: "ellipsis",
              justifyContent: "flex-start"
            }}>
            <ParentSize
              style={{
                width: '50%',
              }}
            >
              {(parent) => (
                //parent component passes his css properties to DonutChart
                (<DonutChart
                  width={parent.width}
                  height={parent.height}
                  halfSize={parent.width / 2}
                  dataToShow={outcomeCounters.map(({ name, count }, index) => ({
                    id: intl.messages[name?.toUpperCase()] ?? name,
                    value: count,
                    color: colors[index],
                  }))}
                  total={total}
                  themeMode={theme.palette.mode}
                  text={intl.messages.OUTCOMES}
                />)
              )}
            </ParentSize>
            <GraphsLegend
              height="90%"
              legendData={outcomeCounters?.map(({ name }) => name)}
              legendColor={colors?.map((x) => x[theme.palette.mode])}
            />
          </Box>
        }
      />
    </FullSizeFlexBox>
  );
};

export default AppointmentsOutcomeCounters;
